<template>
  <v-card :disabled="loading" outlined>
    <v-card-title>Preencha os campos</v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-form ref="form">
        <v-row dense>
          <v-col cols="12" sm="12" md="12">
            <span>Nome *</span>
            <v-text-field
              v-model="form.nome"
              placeholder="Informe seu nome"
              type="text"
              :rules="[rules.required]"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <span>Celular (com DDD) *</span>
            <v-text-field
              v-model="form.celular"
              type="text"
              placeholder="(99) 99999-9999"
              v-mask="'(##) #####-####'"
              :rules="[rules.required]"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <span>Observações (opcional)</span>
            <v-textarea v-model="form.comentarios" type="text" outlined dense />
          </v-col>
        </v-row>
      </v-form>
      <v-checkbox v-model="acceptPolitica">
        <template v-slot:label>
          <a @click.stop="$refs.PoliticaPrivacidade.show()" href="#">Politica de Privacidade</a>
        </template>
      </v-checkbox>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions style="justify-content: center">
      <v-btn color="red" @click="onEnviar()" dark :loading="loading">Enviar</v-btn>
    </v-card-actions>
    <PoliticaPrivacidade ref="PoliticaPrivacidade" />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import rules from "@/helpers/rules";
import Lead from "@/services/Lead";

export default {
  name: "DialogFormulario",

  components: {
    PoliticaPrivacidade: () => import("./PolicitaPrivacidade")
  },

  data() {
    return {
      loading: false,
      rules,
      form: {
        nome: "",
        celular: "",
        comentarios: ""
      },
      acceptPolitica: true,
      serviceLead: new Lead()
    };
  },

  computed: {
    ...mapGetters("veiculo", ["getSelectedVeiculo"]),
    ...mapGetters("vendedor", ["getVendedor", "getEmpresa", "getMidia"])
  },

  methods: {
    onEnviar() {
      if (!this.$refs.form.validate()) {
        this.$swal("", "Preecha os campos obrigatórios", "warning");
        return;
      } else if (!this.acceptPolitica) {
        this.$swal(
          "",
          "Para continuar aceite os termos da Politica de Privacidade",
          "warning"
        );
        return;
      }

      this.enviar();
    },

    async enviar() {
      try {
        this.loading = true;
        this.serviceLead.saveLead(
          this.form.nome,
          this.form.celular,
          this.form.comentarios,
          this.getSelectedVeiculo.idVeiculo,
          this.getSelectedVeiculo.descricao,
          this.getVendedor,
          this.getEmpresa,
          this.getMidia
        );
        this.$refs.form.reset();
        this.$swal(
          "",
          "Enviado com sucesso, em breve o vendedor entrará em contato com você. Obrigado",
          "success"
        );
      } catch (error) {
        console.error(error);
        this.$router.push({ name: "Erro" });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  span {
    font-weight: 500;
    font-size: 11pt;
    color: black;
  }
}
</style>
